import React, { useEffect, useRef, useState } from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ReactGA from 'react-ga'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { selectStory, loadStory } from './store/storiesReducer'
import { selectExhibit } from './store/exhibitReducer'
import { StoryItemFactory } from '@Pass-It-Down/story-item-react'
import api from './exhibitApi'

import './Story.css'
import './Ads.css'

function Story() {
  const { params }  = useRouteMatch()
  const id = params.id
  const backLink = `/gameday/${params.name}/program`

  const dispatch = useDispatch()
  const story = useSelector(selectStory) || { assets: [] }
  const exhibit = useSelector(selectExhibit)
  const cardRef = useRef(null)
  const [storyBackWidth, setStoryBackWidth] = useState(100)

  useEffect(() => {
    dispatch(loadStory(id))
  }, [dispatch, id])

  useEffect(() => {
    if(!story || !story.title) return

    ReactGA.event({
      category: 'View',
      action: 'Story',
      label: `Title: ${story.title}`
    })
  }, [story])

  useEffect(() => {
    setStoryBackWidth(cardRef.current.offsetWidth - 48)
  }, [cardRef.current])

  const adClick = (event, href) => {
    event.preventDefault()

    ReactGA.outboundLink(
      { label: `Ad Click: ${href}` },
      () => { window.location.href = href }
    )
  }

  const bannerAds = story.assets
    .filter(item => item.isBannerAd)
    .map(asset => StoryItemFactory(asset, adClick, api, 0, 50))
    .filter(item => item)

  const bannerAd = bannerAds.length > 0 ? bannerAds[0] : ''
  const storyItems = story.assets
    .filter(item => !item.isBannerAd)
    .map(asset => StoryItemFactory(asset, adClick, api, 0, 250))
    .filter(item => item)

  const [ firstStory, ...otherStories] = storyItems

    return (
      <div >
        <Card className='c-container' elevation={0} square={true} >
          <CardContent ref={cardRef}>
            { bannerAd }
            { firstStory }
            <Typography className='c-title'> { story.title } </Typography>
            <Typography className='c-description'> { story.description } </Typography>
            { otherStories }
            <Link className='c-story-back' to={backLink} style={{background: exhibit.mainColor, width: storyBackWidth }}>Back to Gameday</Link>
          </CardContent>
        </Card>
      </div>
    )
}

export default Story
